import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pnrDiscoveryQueryKeys } from '~/hooks/apis/flights/usePnrDiscoveries';

import { createPnrImportOrder } from '~/services/OrdersService';

export function useCreatePnrImportOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPnrImportOrder,
    onSettled: () => queryClient.invalidateQueries({ queryKey: pnrDiscoveryQueryKeys.all }),
  });
}
